var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 284,
    viewBox: "0 0 273 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4502_41532)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.814,
    y: 76,
    width: 71.3704,
    height: 71.3704,
    rx: 35.6852,
    fill: "#065EEA",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.03 156.461C134.815 158.669 138.183 158.669 139.968 156.461L150.02 144.025H122.979L133.03 156.461Z",
    fill: "#065EEA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4502_41532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.464 110.956C142.358 110.956 147.152 106.118 147.152 100.169C147.152 94.2199 142.358 89.3818 136.464 89.3818C130.57 89.3818 125.777 94.2199 125.777 100.169C125.777 106.118 130.57 110.956 136.464 110.956ZM136.464 92.9776C140.394 92.9776 143.589 96.203 143.589 100.169C143.589 104.135 140.394 107.361 136.464 107.361C132.535 107.361 129.339 104.135 129.339 100.169C129.339 96.203 132.535 92.9776 136.464 92.9776Z",
    fill: "white",
    stroke: "#E7F0FF",
    strokeWidth: 0.669097
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.815 133.546C132.759 133.546 128.681 132.512 125.597 130.442C122.72 128.538 121.147 125.93 121.147 123.094C121.147 120.259 122.72 117.63 125.597 115.705C131.807 111.587 141.866 111.587 148.033 115.705C150.89 117.609 152.483 120.217 152.483 123.053C152.483 125.888 150.91 128.517 148.033 130.442C144.929 132.512 140.872 133.546 136.815 133.546ZM127.315 118.313C125.328 119.638 124.252 121.335 124.252 123.115C124.252 124.874 125.349 126.571 127.315 127.875C132.469 131.332 141.162 131.332 146.316 127.875C148.302 126.551 149.379 124.854 149.379 123.074C149.379 121.314 148.282 119.617 146.316 118.313C141.162 114.877 132.469 114.877 127.315 118.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.988 117.056V119.788C144.74 120.406 145.999 122.069 145.999 124.02V125.517C145.999 126.345 145.326 127.014 144.493 127.014C143.661 127.014 142.988 126.345 142.988 125.517V124.02C142.988 123.194 142.314 122.524 141.483 122.524C140.652 122.524 139.978 123.194 139.978 124.02V125.517C139.978 126.345 139.305 127.014 138.472 127.014C137.64 127.014 136.967 126.345 136.967 125.517V124.02C136.967 122.069 138.226 120.406 139.978 119.788V115.269L132.451 115.599V120.936C133.351 121.454 133.957 122.421 133.957 123.529C133.957 125.182 132.609 126.522 130.946 126.522C129.283 126.522 127.936 125.182 127.936 123.529C127.936 122.421 128.541 121.454 129.441 120.936V117.93V114.457L132.451 113.536L139.978 113.215L142.988 114.061V117.056Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4502_41532",
    x: 0.449875,
    y: 0.168985,
    width: 272.1,
    height: 282.846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24.5336
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50.1823
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.45098 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4502_41532"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4502_41532",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4502_41532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.6065,
    height: 44.6065,
    fill: "white",
    transform: "translate(114.197 89.3818)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOnMap);
export default __webpack_public_path__ + "static/media/locationOnMap.8b025b76b71278d6cfcaa22381b23d12.svg";
export { ForwardRef as ReactComponent };